import script from "./docBioAddOn.vue?vue&type=script&setup=true&lang=ts"
export * from "./docBioAddOn.vue?vue&type=script&setup=true&lang=ts"

import "./docBioAddOn.vue?vue&type=style&index=0&id=e63142bc&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e63142bc"]])

export default __exports__